import { render, staticRenderFns } from "./OnboardingPhotoIndex.vue?vue&type=template&id=53c5e34c&scoped=true&"
import script from "./OnboardingPhotoIndex.vue?vue&type=script&lang=js&"
export * from "./OnboardingPhotoIndex.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPhotoIndex.vue?vue&type=style&index=0&id=53c5e34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5e34c",
  null
  
)

export default component.exports